export default [
  {
    path: "/settings/terminals",
    name: "LocationAndTax",
    component: () => import("@/views/3pl/Settings/LocationAndTax/index"),
  },
  {
    path: "/settings/terminals/new-location",
    name: "NewLocation",
    component: () => import("@/views/3pl/Settings/LocationAndTax/NewLocation"),
  },
  {
    path: "/settings/terminals/edit-location",
    name: "EditLocation",
    component: () => import("@/views/3pl/Settings/LocationAndTax/EditLocation"),
  },
  // {
  //   path: "/settings/terminals/edit-tax",
  //   name: "EditTax",
  //   component: () => import("@/views/3pl/Settings/LocationAndTax/EditTax"),
  // },
];
